import classNames from "classnames";
import { isNodeSelected } from "./../is-node-selected";
import { getPluginContainerClassNames, getPluginFocusClassNames } from "./../node-styles";
const getContainerClasses = (editor, nodeId, isMobile) => {
  const isFocused = isNodeSelected(editor.state, nodeId);
  return classNames(getPluginContainerClassNames(isMobile), getPluginFocusClassNames(isFocused));
};
export {
  getContainerClasses
};
//# sourceMappingURL=get-container-classes.js.map
